module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Form-ef5b1d6f97b964bc9f9cea9e955d09b9.png";